<template> <!-- #Pendiente eliminar antiguas NavBar y NewNavbarFactoring -->
	<div class="dashboard-navbar" >
		<!-- Menu Btn -->
		<v-layout wrap row align-start justify-start style="position:fixed;z-index:1;margin: 10px">
			<v-flex xs12 @click="setOpenMenu()">
				<v-icon class="rc-menuPanelBtn">menu</v-icon>
			</v-flex>
		</v-layout>
		<!-- List Menu -->
    	<v-navigation-drawer  id="rc-menuPanel" v-model="drawer" fixed class="rc-menuDrawer">
			<v-list :style="{ marginTop: devAlertOffset + 'px' }"  class="transparent pa-2">
        		<!-- Mi Panel -->
				<v-flex v-for="(panelSolicitanteMenu, index) in panelSolicitanteMenus" :key="`${panelSolicitanteMenu.icon}-${index}`">
					<v-list-tile v-if="empresas_usuario == 0 && panelSolicitanteMenu.text != 'Firmas Pendientes'" 
					:disabled="panelSolicitanteMenu.text != 'Mi panel' && panelSolicitanteMenu.text != 'Mis datos' && panelSolicitanteMenu.text != 'Mis empresas'" 
					class="v-list-item rc-list-item rc-listItem-pad " 
					:class="panelSolicitanteMenu.text != 'Mi panel' && panelSolicitanteMenu.text != 'Mis datos' && panelSolicitanteMenu.text != 'Mis empresas' ? 'no-ctive' : ''"
					:active-class="activeClassMenu" 
					:to="panelSolicitanteMenu.to.path">
						<div style="text-align: center; width: 100%; line-height: 1;">
							<span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">{{ panelSolicitanteMenu.icon }}</span>
							<div class="rc-listItem-title">{{ panelSolicitanteMenu.text }}</div>
						</div>
					</v-list-tile>
					<v-list-tile v-else-if="panelSolicitanteMenu.text == 'Firmas Pendientes' && mostrarMenuFirmas" class="v-list-item rc-list-item rc-listItem-pad" :active-class="activeClassMenu" :to="panelSolicitanteMenu.to.path">
						<div style="text-align: center; width: 100%; line-height: 1;">
							<span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">{{ panelSolicitanteMenu.icon }}</span>
							<div class="rc-listItem-title">{{ panelSolicitanteMenu.text }}</div>
						</div>
					</v-list-tile>
					<v-list-tile v-else-if="panelSolicitanteMenu.text != 'Firmas Pendientes'" class="v-list-item rc-list-item rc-listItem-pad" :active-class="activeClassMenu" :to="panelSolicitanteMenu.to.path">
						<div style="text-align: center; width: 100%; line-height: 1;">
							<span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">{{ panelSolicitanteMenu.icon }}</span>
							<div class="rc-listItem-title">{{ panelSolicitanteMenu.text }}</div>
						</div>
					</v-list-tile>
				</v-flex>
			</v-list>
		
		</v-navigation-drawer>
	</div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	import { mapState } from "vuex";
	import { panelSolicitanteMenus, panelInversionistaMenus } from "@/models/DashboardLinks";
	
	@Component({
		props: {
			// datos
			tipo_menu: Number,
			sii: Boolean,
			certificado: Boolean,
			devAlertOffset: {
				type: Number,
				default: 0
			}

        },
		computed: {
			...mapState(["user", "setOpenMenuPanel", "siiConfigurations", "empresas_usuario", "businesSelected"]),
			activeClassMenu() {
				return "rc-menuPanelActive";
			},
			activeClassMenuAlert(){
				return "rc-listItem-alert-active"
			},
			valMisDatos(){
				return (this.$props.sii == false && this.$props.certificado == false) || (this.$props.sii == true && this.$props.certificado == false) || (this.$props.sii == false && this.$props.certificado == true)
			},
			showtable(){
				return this.$store.state.user.id == 6984 || this.$store.state.user.id == 28 || this.$store.state.user.id == 167 || this.$store.state.user.id == 274 || this.$store.state.user.id == 123;
			},
			mostrarMenuFirmas(){
				return this.$store.state.liquitech != null && this.$store.state.liquitech == true
			}
		},
		data() { // Data Menu
			return {
				// Menu Solicitante general
				panelSolicitanteMenus,
				panelInversionistaMenus,
				title: null,
				drawer: false,
				responsive: false,
				dark: true,
				show: false,
				mostrarFirmas: false
			}
		},
		// beforeMount() {}, // Antes de Montar el componente
		// beforeUpdate(){}, // Antes de Actualizar el componente
		mounted(){
			 // @ts-ignore
			this.onResponsive();
			// @ts-ignore
			window.addEventListener("resize", this.onResponsive);
			
		},
		methods:{
			onResponsive() {
				if (window.innerWidth >= 1264){
					this.hasClassMenu();
					this.drawer = true;
					if(this.$props.tipo_menu === 2 || this.$props.tipo_menu === 3){ // Modifica variable para expandir o cerrar el menu lateral Inversionista
						this.$store.commit("setOpenMenuPanel", true);
					}
				}
				if (window.innerWidth < 960) {
					this.$data.responsive = true;
				} else {
					this.$data.responsive = false;
				}
			},
			setOpenMenu(){
				if(this.$data.drawer){
					this.drawer = false;
					this.$store.commit("setOpenMenuPanel", false);
				}else{
					this.drawer = true;
					this.$store.commit("setOpenMenuPanel", true);
				}
			},
			hasClassMenu(){
				if(document.getElementById('rc-menuPanel').className.match(/\bv-navigation-drawer--open\b/)){
					this.drawer = true;
					this.$store.commit("setOpenMenuPanel", true);
				}else{
					this.drawer = false;
					this.$store.commit("setOpenMenuPanel", false);
				}
			}
		}
	})
	export default class SideBarPanel extends Vue {}
</script>

<style lang="scss" scoped>
	.no-ctive::v-deep a{
		opacity: 0.5;
	}
	.rc-menuPanelBtn{
		cursor: pointer; 
		color: $rc-prim-n1;
	}

	.rc-listItem-title{
		font-weight: 600;
	}

	.v-list{
		padding: 5px 0px !important;
	}
	
	.rc-listItem-pad{
		padding: 5px 5px;
	}
	.rc-text-color-alert{
		color: #E83F29;
	}
	
	/* Menu */
	.rc-list_ico{
		height: 20px;
		width: 20px;
	}
	.rc-right-bar{
		height: calc(100vh - 64px);
		background-color: $rc-escala5;
	}

	.rc-noml{
		margin-left: 0 !important;
	}

	.rc-menuDrawer{
		margin-top:64px !important;
		z-index:1; 
		width:150px !important; 
		height: calc( 100vh - 64px ) !important; 
		min-height: calc( 100vh - 64px ) !important; 
	}

	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				
			}@else if $breakpoint == "large"{
				
			}@else if $breakpoint == "medium-to-large"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small-to-medium"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important; 
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}
		}
	}
	@media (min-width:1264px) {

    .custom-margin{
      margin-left: 5px;
	}
  }
  @media (max-width:1264px) {

    .custom-margin{
      margin-left: 0px;
    }
  }
</style>
